<template>
    <q-page class="q-pa-md fullscreen-height">
        <!-- DIALOGO DE CONFIRMACION PARA SOLICITAR VEHICULO-->
        <q-dialog v-model="dialogSolicitar" persistent>
            <q-card>
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-information-variant" color="info" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h5 q-ml-lg">¿Confirmas que estas solicitando el modelo del vehiculo
                                <strong>{{ selectModelo.marca }}</strong>,
                                <strong>{{ selectModelo.version }}</strong>.?</span>
                        </div>
                    </div>
                    <div class="row doc-note">
                        <p class="doc-note__title">Aviso</p><br>
                        <p class="">Al hacer una solicitud debera esperar a que un Asistente aprube la información.</p>
                    </div>
                </q-card-section>
                <q-card-actions align="right">
                    <q-btn label="CANCELAR" @click="cancelarSolicitar()" />
                    <q-btn label="Aceptar" color="primary" @click="PostSolicitudVehiculo" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-card class="q-pa-md q-mt-md full-height-minus-margin" style="max-height: calc(100vh - 120px);">
            <div class="row q-col-gutter-md q-pa-md q-mt-sm full-height-content-area">
                <div class="col-12 col-md-3   q-pa-md bg-white">
                    <div class="text-h5 text-weight-bold text-center text-grey-8 q-my-lg">
                        Encuentra tu auto
                    </div>
                    <!-- FILTRAR POR AÑO -->
                    <q-select outlined dense v-model="filtros.marca" :options="opcionesMarcas" label="Filtrar por Marca"
                        clearable class="q-mb-md" />

                    <!-- FILTRAR POR AÑO -->
                    <q-select outlined dense v-model="filtros.anio" :options="opcionesAnios" label="Filtrar por año"
                        clearable class="q-mb-md" />

                    <!-- FILTRAR POR TIPO DE VEHICULO -->
                    <q-select outlined dense v-model="filtros.tipovehiculo" :options="opcionesTipos"
                        label="Filtrar por Tipo de Vehiculo" clearable class="q-mb-md" />

                    <q-select outlined dense v-model="filtros.version" :options="opcionesVersiones"
                        label="Filtrar por Versión" clearable class="q-mb-md" />

                    <!-- FILTRAR POR COLOR -->
                    <q-select outlined dense v-model="filtros.color" :options="opcionesColores"
                        label="Filtrar por color" clearable class="q-mb-md" />
                </div>

                <div class="col-12 col-md-9 scroll-area" style="max-height: calc(100vh - 200px);">
                    <div class="row q-col-gutter-md justify-start">
                        <div v-for="auto in autosFiltrados" :key="auto._id" class="col-12 col-sm-6 col-md-4">
                            <q-card bordered>
                                <q-carousel v-if="auto.imagenes && auto.imagenes.length" v-model="slide_detalles_auto"
                                    animated swipeable navigation height="200px" infinite>
                                    <q-carousel-slide v-for="(img, index) in auto.imagenes" :key="index" :name="index"
                                        :img-src="img.imagBase64" />
                                </q-carousel>

                                <q-card-section>
                                    <div class="text-h6">{{ auto.modelo }} - {{ auto.version }}</div>
                                    <div class="text-caption">Año: {{ auto.anio }} </div>
                                    <div class="text-caption"> Color: {{ auto.color }}</div>
                                    <div class="text-caption">Tipo: {{ auto.tipovehiculo }}</div>
                                    <div class="text-subtitle2 text-primary q-mt-sm">
                                        ${{ parseFloat(auto.precio).toLocaleString() }}
                                    </div>
                                </q-card-section>

                                <q-card-actions align="right">
                                    <q-btn flat color="primary" label="Detalles" />
                                    <q-btn flat color="secondary" icon="mdi-send" label="Solicitar"
                                        @click="DialogSolicitarVehiculo(auto)" />
                                </q-card-actions>
                            </q-card>
                        </div>

                        <!-- Mensaje cuando no hay resultados -->
                        <div v-if="autosFiltrados.length === 0" class="col-12 text-center q-mt-xl">
                            <q-icon name="search_off" size="64px" color="grey-5" />
                            <div class="text-subtitle2 q-mt-sm">No se encontraron resultados</div>
                        </div>
                    </div>
                </div>
            </div>
        </q-card>
    </q-page>
</template>
<script>
import axios from "axios";
import { mapGetters } from 'vuex'
import { QSpinnerClock } from 'quasar'
import moment from 'moment';
export default {
    data() {
        return {
            slide_detalles_auto: 0,
            filtros: {
                anio: null,
                color: null,
                tipovehiculo: null,
                marca: null,
                version: null,
            },

            dialogSolicitar: false,
            selectModelo: {}
        }
    },
    computed: {
        userStore() {
            return this.$store.state.auth.usuario;
        },
        autos() {
            return this.$store.state.auth.listModelosStore;
        },
        opcionesAnios() {
            return [...new Set(this.autos.map(a => a.anio))].sort()
        },
        opcionesColores() {
            return [...new Set(this.autos.map(a => a.color))]
        },
        opcionesTipos() {
            return [...new Set(this.autos.map(a => a.tipovehiculo))]
        },
        opcionesMarcas() {
            return [...new Set(this.autos.map(a => a.marca))]
        },
        opcionesVersiones() {
            return [...new Set(this.autos.map(a => a.version))]
        },
        autosFiltrados() {
            return this.autos.filter(auto => {
                const { anio, color, tipovehiculo, marca, version } = this.filtros
                return (!anio || auto.anio === anio) &&
                    (!color || auto.color === color) &&
                    (!tipovehiculo || auto.tipovehiculo === tipovehiculo) &&
                    (!marca || auto.marca === marca) &&
                    (!version || auto.version === version)
            })
        }
    },
    created() {
        this.GetModelos();
    },
    methods: {
        async PostSolicitudVehiculo() {
            let objeto = {
                _id: '',
                _id_usuario: this.userStore._id,
                _id_automodelo: this.selectModelo._id,
                fecha_solicitud: new Date().toLocaleString('es-MX'),
                fecha_aceptacion: '',
                fecha_rechazo: '',
                notas: '',
                estatus: 'Enviada',
            }
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Solicitando. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Catalogos/PostSolicitudVehiculo', objeto)
                console.log(respuesa)
                this.$q.notify({ type: 'positive', position: 'top-right', message: `Su solicitud se ha enviado correctamente.` });
                this.dialogSolicitar = false
                this.$q.loading.hide()
            } catch (error) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: `Error al enviar su solicitud.` });

                console.log(error)
            }
        },
        async GetModelos() {
            this.loading = true
            try {
                let respuesa = await axios.get('Autos/GetListaModelosxMarca/Todos')
                console.log(respuesa)
                this.$store.state.auth.listModelosStore = respuesa.data
                this.loading = false

            } catch (error) {
                this.loading = false
                console.log(error)
            }
        },
        cancelarSolicitar() {
            this.dialogSolicitar = false
        },
        DialogSolicitarVehiculo(item) {
            this.selectModelo = item
            this.dialogSolicitar = true
        }
    }
}
</script>
<style>
.fullscreen-height {
    height: calc(100vh - 120px) !important;
    /* Adjust 50px if you have a header/footer or other fixed elements */
    display: flex !important;
    flex-direction: column !important;
}

/* Makes the q-card fill the remaining height of the page */
.full-height-minus-margin {
    flex-grow: 1 !important;
    display: flex !important;
    flex-direction: column !important;
}

/* Makes the content area within the q-card fill its height */
.full-height-content-area {
    flex-grow: 1 !important;
    display: flex !important;
    /* Use flexbox for inner layout */
}

/* This is the key for the scrollable area */
.scroll-area {
    flex-grow: 1 !important;
    /* Allows it to take available height */
    overflow-y: auto !important;
    /* Enables vertical scrolling when content overflows */
    height: 100% !important;
    /* Important for flex items to correctly calculate their height */
}

.doc-note {
    background-color: #f0f4f8;
    /* Fondo claro */
    border-left: 4px solid #007BFF;
    /* Línea de color azul en el borde izquierdo */
    padding: 16px;
    margin: 16px 0;
    border-radius: 8px;
    color: #333;
    /* Color de texto */
    font-family: Arial, sans-serif;
}

.doc-note__title {
    margin: 0 0 8px 0;
    font-weight: bold;
    color: #007BFF;
    /* Mismo tono del borde para coherencia */
    font-size: 16px;
}

.doc-note p {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
}
</style>